import { useMemo } from 'react'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import determineOfferFeatureSymbol from 'lib/offer/determineOfferFeatureSymbol'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import type { DrawerHotelAmenity } from './types'

interface Props {
  amenity: DrawerHotelAmenity
}

function AmenityItem({ amenity }: Props) {
  const Icon = useMemo(
    () => getOfferFeatureIcon(
      determineOfferFeatureSymbol(amenity.icon) ?? determineOfferFeatureSymbol(amenity.name),
    ),
    [amenity.icon, amenity.name],
  )

  return (
    <BodyTextBlock variant="medium" startIcon={<Icon />}>
      {amenity.name}
    </BodyTextBlock>
  )
}

export default AmenityItem
